"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembershipValidationErrorValidation = void 0;
class MembershipValidationErrorValidation {
    static isValid(enumValue) {
        if (typeof enumValue !== "number")
            return false;
        if (!(0 <= enumValue && enumValue <= 2)) {
            return false;
        }
        return true;
    }
}
exports.MembershipValidationErrorValidation = MembershipValidationErrorValidation;
